import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { StaffsHelpbuttonService } from '../../../services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { StaffBasic } from 'src/app/models/helpbutton-models/helpbutton-staff-basic.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-helpbutton-staff-dashboard',
  templateUrl: './helpbutton-staff-dashboard.component.html',
  styleUrls: ['./helpbutton-staff-dashboard.component.scss']
})
export class HelpbuttonStaffDashboardComponent implements OnInit, OnDestroy {

  staff;
  getStaffSubscriptionRefresh: Subscription;
  getStaffInfoSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute,
              private staffsService: StaffsHelpbuttonService,
              private router: Router,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getStaffInfo();
    this.getStaffSubscriptionRefresh = this.staffsService.refreshStaffListen().subscribe(
      (res) => {
        this.getStaffInfo();
      }
    );
  }

  public getStaffInfo() {
    const internalId = this.activatedRoute.snapshot.params['staffid'];
    this.getStaffInfoSubscription = this.staffsService.getStaffInfo(internalId).subscribe(
      (res) => {
        this.staff = new StaffBasic();
        Object.assign(this.staff, res['data']['staffDetails']);
      },
      (error) => {
        this.router.navigate(['../../../staffs'], {relativeTo: this.activatedRoute});
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-user-cog', 'helpbutton-page.staff detail', '/helpbutton/staffs', [new BRoute('helpbutton-page.helpbutton', '/helpbutton'), new BRoute('helpbutton-page.staffs', '/helpbutton/staffs'), new BRoute('helpbutton-page.staff detail')]));
  }

  ngOnDestroy() {
    if (this.getStaffSubscriptionRefresh) { this.getStaffSubscriptionRefresh.unsubscribe(); }
    if (this.getStaffInfoSubscription) { this.getStaffInfoSubscription.unsubscribe(); }
  }

}
